import React, { useEffect, useState, useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link, useLocation } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import _ from "lodash";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { vendorServices } from "../../services/vendorEvaluationServices";
import VendorBulkUpload from "../common/vendorbulkUploadModal";
import samplePackageFile from "../../assests/document/Vendor_Base_Assesment.xls";
import { isEmptyDash, strToDate } from "../../constant";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style20 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const initialColumns = [
  { id: "eventId", label: "Event ID", isSort: true, sortLabel: "asc" },
  { id: "eventCreationDate", label: "Event Creation Date", isSort: true, sortLabel: "asc" },
  { id: "eventCreatedBy", label: "Event created By", isSort: true, sortLabel: "asc" },
  { id: "numberOfVendors", label: "Number of Vendors", isSort: true, sortLabel: "asc" },
  /* { id: "col5", label: "Departments" },
   { id: "col6", label: "Rating" },*/
  { id: "status", label: "Status", isSort: true, sortLabel: "asc" },
  { id: "progress", label: "Progress", isSort: true, sortLabel: "asc" },
];
const vendorEvaluationrows = [
  {
    col1: (
      <Link
        className="solutions_block_body"
        style={{ textDecoration: "none" }}
        to="/admin/hod_vendor_performance_evaluation"
      >
        10001
      </Link>
    ),
    col2: "26-07-2024",
    col3: "Amit Sharma",
    col4: 5,
    // col5: "Engineering",
    // col6: "4.5",
    col7: "Pending",
    col8: "20%",
  },
];
function VendorEvaluation() {
  const [columns, setColumns] = useState(initialColumns);
  const [openfinacialyearmodal, setOpenFinacialYearModal] = useState(false);
  const [openselectvendorevaluationmodal, setOpenSelectVendorEvaluationModal] =
    useState(false);
  const [openevaluationsuccessmodal, setOpenEvaluationSuccessModal] =
    useState(false);
  const [opendepartmenthodselection, setOpenDepartmentHodSelection] =
    useState(false);
  const [opendepartmenthodsesuccess, setOpenDepartmentHodSuccess] =
    useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [openBulkUploadModal, setOpenBulkUploadModal] = useState(false);
  const createTableArr1 = [
    { label: "Vendor code", name: "vendorCode", value: "", options: [], errMsg: "" },
    { label: "Vendor Name", name: "vendorName", value: "", options: [], errMsg: "" },
    { label: "Category", name: "category", value: "", options: [], errMsg: "" },
    { label: "Package Name", name: "packageName", value: "", options: [], errMsg: "" },
    { label: "Project Name", name: "projectName", value: "", options: [], errMsg: "" },
  ];

  const [openDefaulfFields, setOpenDefaulfFields] = React.useState(false);
  const [createTableArr, setCreateTableArr] = useState(createTableArr1);
  const [projectCreationlist, setProjectCreationlist] = useState({ events: [] });
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [departHOD, setDepartHOD] = useState([]);
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  const [checked, setChecked] = React.useState(true);

  useEffect(() => {
    setChecked(false);
  }, []);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;
    columnsInit[index].sortLabel = newSortLael;
    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };
  useEffect(() => {
    getVendorEvaluationListing(requestPayload, filterText, filterFormData);
  }, [requestPayload, filterText]);

  const getVendorEvaluationListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }
    vendorServices
      .getVendorEvaluationListing(param)
      .then((res) => {
        // throw errors
        if (res.data.success === true) {
          setProjectCreationlist(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message} `,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getVendorEvaluationListing(requestPayload, filterText);
  };

  const onsetOpenDefaulfFields = (param) => {
    setOpenDefaulfFields(param);
  };
  const onBulkUploadSubmit = (financialYear, fileDataParam, createTableArr) => {
    setIsLoading(true);
    let isValid = true;
    for (let i = 0; i < createTableArr.length; i++) {
      if (isEmptyDash(createTableArr[i].value)) {
        createTableArr[i].errMsg = `Please fill this required field.`;
        isValid = false;
      } else {
        createTableArr[i].errMsg = ``;
      }
    }
    if (isValid) {
      let dataArr = [];
      for (let i = 0; i < createTableArr.length; i++) {
        let obj = {
          excelColumn: createTableArr[i].value,
          field: createTableArr[i].name,
        };
        dataArr.push(obj);
      }
      let formData = new FormData();
      formData.append("financialYear", financialYear["financial_year"]);
      formData.append("file", fileDataParam);
      formData.append("columnMappings", JSON.stringify(dataArr));
      vendorServices
        .createBulkProject(formData)
        .then((res) => {
          openAlert(true, "success", `Event Creation initiated Successfully!`);
          getVendorEvaluationListing(requestPayloadInitials, filterText);
          setOpenDefaulfFields(false);
          // window.location.reload();
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message} `);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    } else {
      setCreateTableArr(createTableArr);
      openAlert(true, "error", `Please fill all mandatory fields.`);
      setIsLoading(false);
    }
  };
  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const depart = [
    { name: 'ENGINEERING', key: 'engineering', id: '65e6c1fac6c901ee2126652e' },
    { name: 'BILL_DESK', key: 'billDesk', id: '669dea2c79be1582faffb67a' },
    { name: 'STORE', key: 'store', id: '669dea4379be1582faffb68c' },
    { name: 'PMO', key: 'pmo', id: '669dea3d79be1582faffb686' },
    { name: 'PROCUREMENT', key: 'procurement', id: '65ef385c403aaa9aea390af0' },
    { name: 'EHS', key: 'ehs', id: '669dea3179be1582faffb680' },
    { name: 'PROJECTS', key: 'projects', id: '66542c6707c67d8ee0773bab' },
    { name: 'QUALITY', key: 'quality', id: '6650775af15003b0287a239f' }
  ];

  const initialFormState = depart.map(department => ({
    departmentId: department.id,
    departmentKey: department.key,
    hod: '',
    email: '',
    tat: ''
  }));

  const [formData, setFormData] = useState([]);

  const onFieldChange = (value, field, index) => {
    const newFormData = [...formData];
    newFormData[index][field] = value;
    setFormData(newFormData);
  };
  const handleClear = () => {
    setFormData(initialFormState);
  };
  useEffect(() => {
    let arr = [];
    for (let index = 0; index < depart.length; index++) {
      arr.push(getAssignSteps(depart[index].name, 'HOD'))
    }
    Promise.all(arr).then(function (values) {
      setDepartHOD(values);
    });
  }, []);


  const getAssignSteps = (department, hod) => {
    let param = `?roles=${hod}&departments=${department}`;
    return vendorServices.getAssignSteps(param)

  };


  const handleSubmit = () => {
    const departmentHodMappings = formData.map(data => ({
      departmentId: data.departmentId,
      departmentKey: data.departmentKey,
      tat: data.tat,
      hod: data.hod
    }));
    const bodyData = { departmentHodMappings };
    setIsLoading(true);
    vendorServices
      .departHodMapping(bodyData)
      .then((res) => {
        if (res.data.success === true) {
          // openAlert(true, "success", `Department HOD Mapping created successfully!`);
          getVendorEvaluationListing(requestPayloadInitials, filterText);
          setOpenDefaulfFields(false);
          setOpenDepartmentHodSelection(false);
          setOpenDepartmentHodSuccess(true);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `Something Went wrong `,
          });
        }

      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message} `);
      })
      .finally((param) => {
        setIsLoading(false);
      });


  };

  useEffect(() => {
    getDeparHod();
  }, []);

  const getDeparHod = () => {
    setIsLoading(true);
    vendorServices
      .getDeparHodListing()
      .then((res) => {
        setFormData(res?.data?.data)
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message} `,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>Vendor Evaluation</h5>
              </div>
              {/* <div className="create_listing_project_div_bcfr">
              <p>My Vendor</p>
              <Switch
                checked={checked}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
              <p>All Vendor</p>
            </div> */}
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"

                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="price_modification_secondarybtn">
                <button
                  onClick={() => setOpenBulkUploadModal(true)}
                  className="create_btn_lr_creations"
                >
                  <AddIcon />
                  Create Evaluation Event
                </button>
                <button
                  className="create_btn_lr_creations"
                  onClick={setOpenDepartmentHodSelection}
                >
                  Department HOD Mapping
                </button>
                {/* <div className="filter_mains">
                <button fdprocessedid="byer54">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-funnel"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"></path>
                    </svg>
                  </span>
                  Filter
                </button>
              </div> */}
              </div>
            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div style={{ width: "100%" }}
                  className="listing_main listing_main_dragdropcontext_body listingmain"
                  // style={{ overflowX: "scroll" }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <table className="dragdropcontext_ondragend_block_row">
                    <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                      <tr>
                        <th className="vendor_tabels">
                          <input type="checkbox" />
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className="vendor_tabels"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)}>
                                  <SwapVertIcon className="swap-sort-ico" />
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {projectCreationlist?.events.length < 1 && <>
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}

                      {projectCreationlist?.events.length > 0 && <>
                        {projectCreationlist?.events?.map((row, rowIndex) => (
                          <tr key={rowIndex} className="maine_tr_vendor">
                            <td>
                              <input type="checkbox" />
                            </td>
                            {columns.map((column, index) => {
                              return column.id === "eventId" ? (
                                <td key={index}>
                                  <Link
                                    className="solutions_block_body"
                                    style={{ textDecoration: "none" }}
                                    to={`/admin/hod_vendor_performance_evaluation/${row?._id}`}
                                  >
                                    {row[column.id]}
                                  </Link>
                                </td>
                              ) : (
                                <td key={index}>
                                  {column.id === "eventCreationDate" ? strToDate(row[column.id]) : row[column.id]}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </>}
                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {projectCreationlist?.events.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(projectCreationlist?.pageSize) * Number(projectCreationlist?.currentPage - 1) + 1
                    } to ${Number(projectCreationlist?.pageSize) * Number(projectCreationlist?.currentPage - 1) + Number(projectCreationlist?.events.length)
                    } of ${projectCreationlist?.totalItems} `}
                </span>
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={projectCreationlist?.totalPages}
                  page={projectCreationlist?.currentPage}
                  onChange={onPaginationChange}
                  renderItem={(item) => (<>
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  </>
                  )}
                />
              </Stack>
            </div>
          </>}

          <VendorBulkUpload
            createTableArr={createTableArr}
            openBulkUploadModal={openBulkUploadModal}
            setOpenBulkUploadModal={setOpenBulkUploadModal}
            onBulkUploadSubmit={onBulkUploadSubmit}
            onsetOpenDefaulfFields={onsetOpenDefaulfFields}
            openDefaulfFields={openDefaulfFields}
            sampleProjectFile={samplePackageFile}
            title="Vendor Evaluation"
          />
          {/* Create Evaluation Event Modal */}

          <Modal
            open={openevaluationsuccessmodal}
            onClose={() => setOpenEvaluationSuccessModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenEvaluationSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkcircleImage} alt="" />
                <p>
                  You have successfully created an
                  <br /> evaluation event
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={() => {
                      setOpenEvaluationSuccessModal(false);
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          {/* Create Evaluation Event Modal */}

          {/* Deparment HOD Mapping Modals  */}
          <Modal
            open={opendepartmenthodselection}
            onClose={() => setOpenDepartmentHodSelection(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style20} className="modal_react_controlpanel_employees departments_row" style={{ height: "35rem" }}>
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Department and HOD Selection
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenDepartmentHodSelection(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div className="department_rows1_hod">
                  <table>
                    <thead>
                      <tr>
                        <th className="row_evaluation_qws">Department Name</th>
                        <th className="row_evaluation_qws">HOD</th>
                        {/* <th className="row_evaluation_qws">Email ID</th> */}
                        <th className="row_evaluation_qws">TAT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {depart.map((department, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "left" }}>
                            <div>{department.name}</div>
                          </td>
                          <td>
                            <div>
                              <select
                                id={`vendorEvual_${index} `}
                                className="form-select select_react_form_vendorlist"
                                aria-label="Default select example"
                                value={formData[index]?.hod || ''}
                                onChange={(e) => onFieldChange(e.target.value, 'hod', index)}
                              >
                                <option value="" disabled>Please Select HOD</option>
                                {departHOD?.map((hod, i) => (
                                  <option key={i} value={hod.data?.data?.assignees[0]?._id}>
                                    {hod.data?.data?.assignees[0]?.name}</option>
                                ))}

                              </select>
                            </div>
                          </td>
                          {/* <td>
                            <div>
                              <input type="text" className="form-control form-ha" value={isEmptyDash(formData[index]?.email) ? formData[index]?.email : ''} disabled
                                onChange={(e) => onFieldChange(e.target.value, 'email', index)} />
                            </div>
                          </td> */}
                          <td>
                            <div>
                              <input type="text" className="form-control form-ha" value={formData[index]?.tat}
                                onChange={(e) => onFieldChange(e.target.value, 'tat', index)} />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="all_btn_modal_listing_evaluation">
                  {/* <button
                    type="button"
                    class="btn clear_btn_status_block_lists"
                    onClick={handleClear}
                  >
                    Clear
                  </button> */}
                  <button
                    type="button"
                    class="btn clear_btn_status_block_lists"
                    onClick={() => {
                      setOpenDepartmentHodSelection(false);
                    }}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          <Modal
            open={opendepartmenthodsesuccess}
            onClose={() => setOpenDepartmentHodSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenDepartmentHodSuccess(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkcircleImage} alt="" />
                <p>
                  Department and HOD selected successfully.
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={() => {
                      setOpenDepartmentHodSuccess(false);
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </Box>
          </Modal>

          <AlertComponent
            alertComponent={alertComponent}
            handleClose={handleClose}
          />
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          {/* Deparment HOD Mapping Modals  */}
        </div>
      </div >
    </>
  );
}

export default VendorEvaluation;
